export const TIPOTEMPLATES = {
  email: 1,
  texto: 2,
}
